import {Budget, Order} from '@/typedef/order';
import _ from 'lodash';
import {Company} from '@/typedef/vendor';

// 根据材料的单位调整数量,根据材料单位的不同，如，米，码千克等，转换数量
function quantityTransferByUnit(value, item) {

    // 面料的计算分针织面料和梭织面料，计算总数量的时候有区分。梭织面料：按单位来，“米”的时候正常，“码”的时候，总数量计算【单耗（米）损耗成衣数量/0.9144】转换成码的总数量值。针织面料：按单位来，“千克”，总数量计算【单耗（米）损耗成衣数量*门幅（米）*克重kg】转还成千克的总数量值

    if (item && item.unitType == '码') {
        return value / 0.9144;
    } else if (item && item.unitType == '千克') {
        return value * item.width * item.gramWeight;
    } else {
        return value;
    }

}


// 拿颜色名称
function getColorName(boms, colorDimId) {

    for (let i = 0; i < boms.length; i++) {
        for (let j = 0; j < boms[i].dims.length; j++) {
            if (boms[i].dims[j].id == colorDimId) {
                return boms[i].dims[j].name;
            }
        }
    }
    return '';
}

export default function calculateBudge(state): Budget {
    if (_.isEmpty(state.order)) {
        // @ts-ignore
        return {};
    }
    const order = state.order as Order;

    const mainBomDims = _.chain(order.boms).find({isMain: true}).get('dims').map('id').value();

    const _exchangeRates = _.chain(order.exchangeRates).reduce((result, value) => {
        result[value.sourceCurrency] = value.rate;
        return result;
    }, {}).value();

    const exchangeRateOf = (currency): [number, undefined | string] => {
        if (currency === 'RMB') {
            return [1, undefined];
        }
        const rate = _.get(_exchangeRates, currency, 0);
        return [rate, rate === 0 ? `没有合适的汇率[${currency}]` : undefined];
    };

    const incomes = _.chain(order.poList).map(({id, name, unitPrice}) => {
        const poQty = _.chain(order.qtyTable).filter((qtyItem) => {
            return qtyItem.refTo === 'PO' && qtyItem.refId === id && _.indexOf(mainBomDims, qtyItem.colorDimId) > -1;
        }).sumBy('quantity').value();
        const [rate, error] = exchangeRateOf(unitPrice.currency);
        return {
            refTo: id, name,
            quantity: poQty,
            income: poQty * unitPrice.amount * rate,
            error,
        };
    }).value();
    // totalIncome为订单总金额
    const totalIncome = _.sumBy(incomes, 'income');

    const stuffQtyGroupByColorDetails = _.chain(order.clothesStuffList).filter(i => ['carton', 'tape'].indexOf(i.stuffType) === -1).map(stuff => {
        //qtyTable里， refTO值为clothesStuff的时候，refId就是指这个材料，然后问题来了.分颜色？分尺码？事实上
        //无论怎么区分，也就是n*n得数据量。

        //现在我想知道的是，分colorDimId的情况..
        //整理一下出现的ColorDimIdGroups

        const stuffQtyGroupByColor = _.chain(order.qtyTable).filter({
            refTo: 'CLOTHES_STUFF',
            refId: stuff.id
        }).groupBy(z => z.colorDimId).map((qlist, key) => {
            const qtyListOfColor = qlist;

            const qty = _.chain(qtyListOfColor).map(({sizeDimId, colorDimId}) => {
                //其实这里不用filter,用find就可以..
                return _.chain(order.qtyTable).filter({refTo: 'PO', colorDimId, sizeDimId}).sumBy('quantity').value();
            }).sum().value();

            // console.log("分颜色:"+key+"拿到对应在po里的数量之总和：",qty);
            const theQuantity = quantityTransferByUnit(qty * (1 + stuff.loss / 100) * stuff.consumption, stuff);
            return {
                stuffId: stuff.id, // 多存一份.
                colorDimId: parseInt(key),
                color: getColorName(order.boms, key),
                stuffType: stuff.stuffType,
                unitType: stuff.unitType,
                unitPrice: stuff.unitPrice.amount,
                currencyUnit: stuff.unitPrice.currency,
                vendorId: stuff.vendorId,
                quantity: quantityTransferByUnit(qty * (1 + stuff.loss / 100) * stuff.consumption, stuff)
            }
        }).value();
        return {stuffId: stuff.id, qtyByColor: stuffQtyGroupByColor}
    }).value();

    const stuffColorQtys = _.filter(_.flatMap(stuffQtyGroupByColorDetails, m => m.qtyByColor), o => o.quantity > 0);
  console.log("材料遍历的情况", order.clothesStuffList);
    // console.log("单纯分颜色的数量",stuffColorQtys);
    // 去掉纸箱胶带
    const clothesStuffs = _.chain(order.clothesStuffList).filter(i => ['carton', 'tape'].indexOf(i.stuffType) === -1).map(stuff => {

        const {id, loss, consumption, unitPrice} = stuff;


        // 分颜色与否..本身，这些数量，服务于不同衣服的..也就是不同bom,不用bomDim
        let totalQuantity = 0;
        switch (stuff.stuffType) {
            case 'fabric':
            case 'sewing_accessories':
            case 'packaging_accessories':
                totalQuantity = _.chain(order.qtyTable).filter({refTo: 'CLOTHES_STUFF', refId: id})
                    .map(({colorDimId, sizeDimId}) => {
                        const qty = _.chain(order.qtyTable).filter({
                            refTo: 'PO',
                            colorDimId,
                            sizeDimId
                        }).sumBy('quantity').value();
                        /*成衣数量*/
                        const qtyIncludeConsume = qty * (1 + loss / 100) * consumption;

                        return quantityTransferByUnit(qtyIncludeConsume, stuff);
                    }).sum().value();
                break;
            // case 'carton':
            // case 'tape':
            //   totalQuantity = _.sumBy(incomes, 'quantity');break;

            case 'carton':

                break;
            default:
                totalQuantity = stuff.totalPieces;
        }
        const vendor = _.chain(state.vendors as Array<Company>).find({uuid: stuff.vendorId}).get('shortName', '').value();

        const [rate, error] = exchangeRateOf(unitPrice.currency);

        const totalCost = totalQuantity * unitPrice.amount * rate;

        return {
            ...stuff,
            refTo: stuff.id,
            totalQuantity,
            totalCost,
            unitCost: unitPrice,
            vendor,
            error,
        };
    }).value();

// 尝试不去掉纸箱胶带
//   const clothesStuffs = _.chain(order.clothesStuffList).map(stuff => {
//     const {id, loss, consumption, unitPrice} = stuff;
//
//     let totalQuantity = 0;
//     switch (stuff.stuffType) {
//       case 'fabric':
//       case 'sewing_accessories':
//       case 'packaging_accessories':
//         totalQuantity = _.chain(order.qtyTable).filter({refTo: 'CLOTHES_STUFF', refId: id})
//           .map(({colorDimId, sizeDimId}) => {
//             const qty = _.chain(order.qtyTable).filter({refTo: 'PO', colorDimId, sizeDimId}).sumBy('quantity').value();
//             /*成衣数量*/
//             const qtyIncludeConsume = qty * (1 + loss / 100) * consumption;
//
//             return quantityTransferByUnit(qtyIncludeConsume, stuff);
//           }).sum().value();
//         break;
//       case 'carton':
//       case 'tape':
//         totalQuantity = _.sumBy(incomes, 'quantity');
//         break;
//       default:
//         totalQuantity = stuff.totalPieces;
//     }
//     const vendor = _.chain(state.vendors.list as Array<Company>).find({uuid: stuff.vendorId}).get('shortName', '').value();
//
//     const [rate, error] = exchangeRateOf(unitPrice.currency);
//     const totalCost = totalQuantity * unitPrice.amount * rate;
//     return {
//       ...stuff,
//       refTo: stuff.id,
//       totalQuantity,
//       totalCost,
//       unitCost: unitPrice,
//       vendor,
//       error,
//     };
//   }).value();
//   console.log("面辅料价格>>>>>>>>>>", clothesStuffs);
    //纸箱胶带金额
    // console.log("我是纸箱胶带的价格", order.budgetCosts);
    // console.log("我是纸箱胶带的合计", _.sumBy(order.budgetCosts, 'totalCost.amount'));


    _.each(clothesStuffs, eachStuff => {
        eachStuff.vendor = _.chain(state.vendors.list as Array<Company>).find({uuid: eachStuff.vendorId}).get('name', '').value();
    });

    const fabrics = _.filter(clothesStuffs, {stuffType: 'fabric'});
    const accessories = _.filter(clothesStuffs, ({stuffType}) => ['fabric', 'carton', 'tape'].indexOf(stuffType) === -1);
    // 纸箱胶带
    const cartons = _.filter(clothesStuffs, {stuffType: 'carton'});
    const polybags = _.filter(clothesStuffs, {stuffType: 'tape'});

    // 比起另外一份表去存一堆数据..是否分开？如果真分开，那就需要， 颜色. 数量 金额了..


    // 加工厂费用
    const processingPlants = _.chain(order.factoryList).map(({id, unitPrice, factoryId}) => {

        // 如果包含主部件，就以主部件为总数
        let totalQuantity = _.chain(order.qtyTable).filter((qtyItem) => {
            return qtyItem.refTo === 'FACTORY_IN_ORDER' && qtyItem.refId === id && _.indexOf(mainBomDims, qtyItem.colorDimId) > -1;
        }).sumBy('quantity').value();
        console.log('order.qtyTable :',_.chain(order.qtyTable).filter((qtyItem) => {
            return qtyItem.refTo === 'FACTORY_IN_ORDER' && qtyItem.refId === id && _.indexOf(mainBomDims, qtyItem.colorDimId) > -1;
        }).value());

        // 如果没有主部件，按其余部件总数
        // if (totalQuantity === 0) {
        //   totalQuantity = _.chain(order.qtyTable).filter((qtyItem) => {
        //     return qtyItem.refTo === 'FACTORY_IN_ORDER' && qtyItem.refId === id && _.indexOf(mainBomDims, qtyItem.colorDimId) == -1;
        //   }).sumBy('quantity').value();
        // }


        const name = _.chain(state.vendors.list as Array<Company>).find({uuid: factoryId}).get('shortName', '').value();

        const [rate, error] = exchangeRateOf(unitPrice.currency);
        return {
            refTo: id, name, totalQuantity,
            totalCost: totalQuantity * unitPrice.amount * rate,
            unitCost: unitPrice,
            factoryId,
            vendorId:factoryId,
            error,
        };
    }).value();

    console.log('order.factoryList :',order.factoryList);

    console.log("列一下这里的工序", order.processes);
    // 工序费用
    const processes = _.chain(order.processes).map((process) => {
      console.log("工序遍历的情况", process);
        const colorDims = _.chain(process.bomIds)
            .flatMap(id => _.chain(order.boms).find({id}).get('dims', []).filter({dimType: 'color'}).map('id').value()).value();

        const totalQuantity = _.chain(order.qtyTable).filter(({refTo, colorDimId}) => refTo === 'PO' && colorDims.indexOf(colorDimId) > -1)
            .sumBy('quantity').value();
        const [rate, error] = exchangeRateOf(process.unitPrice.currency);
        return {
            ...process,
            refTo: process.id,
            totalQuantity,
            totalCost: totalQuantity * process.unitPrice.amount * rate,
            unitCost: process.unitPrice,
            error,
        };
    }).value();


//其他费用
    const budgetCosts = _.chain(order.budgetCosts).map(cost => {
        const [rate, error] = exchangeRateOf(cost.totalCost.currency);
        const vendor = _.chain(state.vendors.list as Array<Company>).find({uuid: cost.vendorId}).get('name', '').value();
        return {
            refTo: cost.id,
            name: cost.name,
            vendor,
            vendorId: cost.vendorId,
            totalCostInMoney: cost.totalCost,
            totalCost: cost.totalCost.amount * rate,
            error,
        };
    }).value();


    // 总金额
    const totalCost = _.sumBy(clothesStuffs, 'totalCost') + _.sumBy(processingPlants, 'totalCost') + _.sumBy(processes, 'totalCost') + _.sumBy(budgetCosts, 'totalCost');
    // 国外订单总金(去除纸箱胶带的面辅料价格总和)
    // const totalCostOut = _.chain(clothesStuffs).filter(i => ['carton', 'tape'].indexOf(i.stuffType) === -1).sumBy('totalCost').value();
    const totalCostOut = _.sumBy(clothesStuffs, 'totalCost');
    // console.log("我是国外订单总金额>>>>>>>>>>", totalCostOut);

    let taxRefund = 0;
    // 成衣出口 && 国内加工，算成衣退税
    if (order.data.tradeMethodType > 0 && order.data.processMethodType === 0) {
        //总金额减去费用预算
        // @ts-ignore
        if (order.data.drawbackRate) {
            // @ts-ignore
            taxRefund = (totalCost - (_.chain(budgetCosts).filter(i => ['纸箱', '胶袋'].indexOf(i.name) === -1).sumBy('totalCost').value())) / (1+order.data.drawbackRate/100) * (order.data.drawbackRate/100);
        } else {
            taxRefund = (totalCost - (_.chain(budgetCosts).filter(i => ['纸箱', '胶袋'].indexOf(i.name) === -1).sumBy('totalCost').value())) / 1.13 * 0.13;
        }
    }
    // 成衣出口 && 国外加工，算面辅料退税
    if (order.data.tradeMethodType > 0 && order.data.processMethodType === 1) {
        // @ts-ignore
        if (order.data.drawbackRate) {
            // @ts-ignore
            taxRefund = totalCostOut / (1+order.data.drawbackRate/100) * (order.data.drawbackRate/100);
        } else {
            taxRefund = totalCostOut / 1.13 * 0.13;

        }
    }


    // 总数量
    const totalQuantity = _.sumBy(incomes, 'quantity');
    const [baseUnitPriceExchangeRate, baseUnitPriceExchangeRateError] = exchangeRateOf(order.data.currencyUnit);
    const cartonAndTape = _.chain(budgetCosts).filter(i => ['纸箱', '胶袋'].indexOf(i.name) != -1).sumBy('totalCost').value();
    const otherBudget = _.chain(budgetCosts).filter(i => ['纸箱', '胶袋'].indexOf(i.name) === -1).sumBy('totalCost').value();

    const officeExpenses = totalIncome * parseFloat(order.data.costRate) / 100;
    const commission = totalIncome * parseFloat(order.data.clientMoneyPercent) / 100;
    const countAmount =totalIncome/totalQuantity/baseUnitPriceExchangeRate;

    //利润 订单总额-总成本-办公-佣金+退税
    const grossProfit = totalIncome - totalCost - officeExpenses - commission + taxRefund;
    const budget = {
        styleNo: order.data.styleNo, budgetCosts,
        totalCost, incomes, fabrics, accessories, processingPlants, processes, taxRefund, cartons, polybags,
        baseUnitPrice: {currency: order.data.currencyUnit, amount: totalIncome/totalQuantity/baseUnitPriceExchangeRate},
        // baseUnitPrice: {currency: order.data.currencyUnit, amount: parseFloat(order.data.price)},
        baseUnitPriceExchangeRate, baseUnitPriceExchangeRateError,
        countAmountPrice:{amount:countAmount,currency: order.data.currencyUnit},
        totalQuantity,
        totalIncome: totalIncome,
        someClothesStuffs: clothesStuffs,
        cartonAndTape: cartonAndTape,
        otherBudget: otherBudget,
        unitCost: totalCost / totalQuantity,
        profitMargin: Math.round(grossProfit / totalCost * 1000) / 10,
        officeExpenses, commission, grossProfit,
        status: 'New',
        orderId: order.data.id, stuffColorQtys
    };

    // 由于现在想要分衣服颜色了.嗯..就得分材料来存储不同颜色成衣下的材料..
    // console.log('budget: %O', budget);
    // @ts-ignore
    return budget;
}
